export default function () {
  return {
    greatGrandfathersExist: false,
    greatGrandfatherPairs: 0,
    greatGrandfatherFirstAlive: 0,
    greatGrandfatherSecondAlive: 0,
  };
}
